import { IChatMessage, type IChatMessageBotOption, type IChatMessageMetadata, ICryptoChannel } from "@listat/r2-core";
import { IChatRepositoryMessage, IChatRepositoryMessageUser } from "@core/office/office-chat-repository/office-chat-repository.types";
import { ChatUtilsService } from "@core/shared/chat-utils.service";

export class OfficeChatAdapterV1Repository {
    constructor(private chatUtils: ChatUtilsService, private cryptoService: ICryptoChannel) {
    }

    public async encryptMessages(messages: IChatMessage[]): Promise<IChatRepositoryMessage[]> {
        const encryptedMessages: IChatRepositoryMessage[] = [];

        for (const item of messages) {

            if (this.chatUtils.isSenderBot(item)) {
                encryptedMessages.push({
                    sender: item.sender,
                    value: await this.cryptoService.EncryptMessage(item.value),
                    options: await this.cryptoService.EncryptObject(item.options),
                });
                continue;
            }

            const newItem: IChatRepositoryMessageUser = {
                sender: item.sender,
                value: await this.cryptoService.EncryptMessage(item.value),
            };

            if (item.metadata) {
                newItem.metadata = await this.cryptoService.EncryptObject(item.metadata);
            }

            encryptedMessages.push(newItem);
        }

        return encryptedMessages;
    }

    public async decryptMessages(messages: IChatRepositoryMessage[]): Promise<IChatMessage[]> {
        const decryptedMessages: IChatMessage[] = [];

        for (const item of messages) {

            if (this.chatUtils.isSenderRepositoryBot(item)) {
                decryptedMessages.push({
                    sender: item.sender,
                    value: await this.cryptoService.DecryptMessage(item.value),
                    options: await this.cryptoService.DecryptObject<IChatMessageBotOption>(item.options),
                });
                continue;
            }

            const userItem = item as IChatRepositoryMessageUser;
            const newItem: { sender: typeof item.sender; value: string; metadata?: IChatMessageMetadata } = {
                sender: userItem.sender,
                value: await this.cryptoService.DecryptMessage(userItem.value),
            };

            if (userItem.metadata) {
                newItem.metadata = await this.cryptoService.DecryptObject<IChatMessageMetadata>(userItem.metadata);
            }

            decryptedMessages.push(newItem);
        }

        return decryptedMessages;
    }
}
